import filterEmpty from '../utilities/filterEmpty';
import formatDateForRequest from '../utilities/formatDateForRequest';

export interface PatientParams {
  corp?: string;
  firstName: string;
  middleName?: string;
  lastName: string;
  dob: string;
  identificationId?: string;
  identificationType?: string;
  memberTags?: string[];
  gender?: string;
  selfDescribe?: string;
  email?: string;
  phone?: string;
  address1: string;
  address2?: string;
  city: string;
  state: string;
  zip: string;
}

export interface PatientData {
  patient: {
    corp?: string;
    first_name?: string;
    middle_name?: string;
    last_name?: string;
    dob?: string | null;
    identification_id?: string;
    identification_type?: string;
    gender?: string;
    self_describe?: string;
    email?: string;
    phone_number?: string;
    memeber_tags?: string[];
  };
  check_payment_address: {
    address1?: string;
    address2?: string;
    city?: string;
    state?: string;
    zip?: string;
  };
}

export default function getNewPatientData(patientParams: PatientParams): PatientData {
  const addressData = patientParams.address2
    ? {
        address1: patientParams.address1,
        address2: patientParams.address2,
        city: patientParams.city,
        state: patientParams.state,
        zip: patientParams.zip,
      }
    : {
        address1: patientParams.address1,
        city: patientParams.city,
        state: patientParams.state,
        zip: patientParams.zip,
      };

  return {
    patient: filterEmpty({
      corp: patientParams.corp,
      first_name: patientParams.firstName,
      middle_name: patientParams.middleName,
      last_name: patientParams.lastName,
      dob: formatDateForRequest(patientParams.dob),
      identification_id: patientParams.identificationId,
      identification_type: patientParams.identificationType,
      gender: patientParams.gender,
      self_describe: patientParams.selfDescribe,
      email: patientParams.email,
      phone_number: patientParams.phone,
      member_tags: patientParams.memberTags,
    }),
    check_payment_address: addressData,
  };
}
